import React from 'react';
import { HStack, Flex } from '@televet/kibble-ui/build/chakra';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { DatePicker, DateRange } from '@televet/kibble-ui/build/components/DatePicker';
import { set, addDays } from 'date-fns';
import { InfoIcon } from 'shared/components/InfoIcon';

interface props {
  date: Date | null;
  onDateChange: (date: Date) => void;
  onDateRemove: () => void;
}

const ScheduleServiceReminderActivation = ({ date, onDateChange, onDateRemove }: props): JSX.Element => {
  const handleAdd = (): void => {
    // Set activation date to tomorrow at 12 PM
    const tomorrow = set(addDays(Date.now(), 1), { hours: 12, minutes: 0 });
    onDateChange(tomorrow);
  };

  const handleRemove = (): void => {
    onDateRemove();
  };

  const handleDateChange = ({ startDate }: DateRange): void => {
    if (!startDate) return;

    if (!!date) {
      startDate = set(startDate, { hours: 12, minutes: 0 });
    }
    onDateChange(startDate);
  };

  return (
    <>
      <Flex align="center" mb={1}>
        <Text fontWeight="bold">Schedule Activation</Text>
        <InfoIcon
          heading="Schedule Activation"
          text="Disabled service reminders can be scheduled to activate on a specific date."
        />
      </Flex>
      {!!date ? (
        <HStack>
          <DatePicker
            startDate={date}
            dateFormat="eeee, MMMM do"
            onDateChange={handleDateChange}
            data-mixpanel-name="Service Reminder Activation Date"
            data-testid="service-reminder-activation-date-select"
          />
          <Button variant="ghostNeutral" iconName="trashcan" size="md" onClick={handleRemove} />
        </HStack>
      ) : (
        <Button variant="ghost" size="md" iconName="plus" onClick={handleAdd}>
          Add Activation Date
        </Button>
      )}
    </>
  );
};

export default React.memo(ScheduleServiceReminderActivation);
